export const renderContentForPdf = (content) => {
    if (typeof content === 'object' && !Array.isArray(content) && content !== null && content.type === 'full_reaction') {
        const extractName = (chemString) => {
            if (typeof chemString !== 'string') return '[Invalid Chemical]';
            const match = chemString.match(/CHEM\[(.*?)\]/);
            return match && match[1] ? match[1] : '[Unnamed Chemical]';
        };
        const reactants = Array.isArray(content.reactants) ? content.reactants.map(extractName).join(' + ') : '';
        const products = Array.isArray(content.products) ? content.products.map(extractName).join(' + ') : '';
        const reagents = Array.isArray(content.reagents) ? content.reagents.join(', ') : '';
        if (reagents) return `${reactants} --[${reagents}]--> ${products}`;
        return `${reactants} --> ${products}`;
    }

    if (Array.isArray(content)) {
        const textArray = content.map((item) => {
            if (typeof item !== 'string') return '[Invalid Data]';
            const chemRegex = /CHEM\[(.*?)\]/;
            const match = item.match(chemRegex);
            return match && typeof match[1] !== 'undefined' ? `[Structure of ${match[1] || 'Unnamed'}]` : item;
        });
        return textArray.join(' → ');
    }

    if (typeof content === 'string') {
        let text = content;
        const smilesRegex = /SMILES\[(.*?)\]/g;
        const smilesReactionRegex = /SMILES\[(.*?)\]>>SMILES\[(.*?)\]/g;
        const latexRegex = /\$\$(.*?)\$\$/g;
        const inlineLatexRegex = /\$(.*?)\$/g;
        text = text.replace(smilesReactionRegex, '[Chemical Reaction]');
        text = text.replace(smilesRegex, '[Chemical Structure]');
        text = text.replace(latexRegex, '[Formula]');
        text = text.replace(inlineLatexRegex, '[Formula]');
        return text;
    }

    if (!content) return '';
    return String(content);
};

export const exportNotesToPDF = (folderName, notes, jsPDFInstance, markedInstance) => {
    const doc = new jsPDFInstance();
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 15;
    const maxWidth = pageW - (margin * 2);
    let currentY = 55;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(30);
    doc.setTextColor(139, 92, 246);
    doc.text('FLASHFONIC', pageW / 2, 20, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(16);
    doc.setTextColor(31, 41, 55);
    doc.text('Listen. Flash it. Learn.', pageW / 2, 30, { align: 'center' });

    doc.setFontSize(22);
    doc.setTextColor(0, 0, 0);
    doc.text(`Flash Notes: ${folderName}`, pageW / 2, 45, { align: 'center' });

    const checkPageBreak = (heightNeeded) => {
        if (currentY + heightNeeded > doc.internal.pageSize.getHeight() - margin) {
            doc.addPage();
            currentY = margin;
        }
    };

    const tokens = markedInstance.lexer(notes);
    tokens.forEach((token) => {
        if (token.type === 'heading') {
            checkPageBreak(15);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0);
            const headingText = doc.splitTextToSize(token.text, maxWidth);
            doc.text(headingText, margin, currentY);
            currentY += headingText.length * 5 + 4;
        }
        if (token.type === 'list') {
            token.items.forEach((item) => {
                checkPageBreak(10);
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10);
                doc.setTextColor(0, 0, 0);
                const itemText = doc.splitTextToSize(`• ${item.text}`, maxWidth - 5);
                doc.text(itemText, margin + 5, currentY);
                currentY += itemText.length * 4 + 2;
            });
        }
        if (token.type === 'paragraph') {
            checkPageBreak(10);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            const pText = doc.splitTextToSize(token.text, maxWidth);
            doc.text(pText, margin, currentY);
            currentY += pText.length * 4 + 2;
        }
        if (token.type === 'space') {
            currentY += 5;
        }
    });
    doc.save(`${folderName}-FlashNotes.pdf`);
};


